export const convertSaveCardObject = (data: Record<string, unknown>): Record<string, unknown> => {
  return {
    comment: data.comment || "",
  };
};
